const ToggleBtn = ({
    isOn,
    onLabel = "Charger",
    offLabel = "Arrêter",
    onToggle,
    backgroundColor = "#3B6ED5",
    toggleColor = "#BBD7FF",
}) => {
    const handleToggle = () => {
        if (onToggle) onToggle(!isOn);
    };

    return (
        <div
            className="toggle-btn"
            style={{ backgroundColor }}
            onClick={handleToggle}
        >
            <span className="toggle-label">{offLabel}</span>
            <div className={`toggle-switch ${isOn ? "on" : "off"}`}>
                <div
                    className="toggle-circle"
                    style={{ backgroundColor: toggleColor }}
                ></div>
            </div>
            <span className="toggle-label">{onLabel}</span>
        </div>
    );
};

export default ToggleBtn;
